import React, { useState, useEffect } from 'react';

const TablaAvanceUnDia = (p) => {

    const class1 = 'text-xs text-bold text-center border-none'
    const class2 = 'text-s text-500 text-center border-none'
    const plan = p.plan;
    const ejecutado = p.ejecutado;
    const uh = +p.uh;
    const dia = +p.dia;
    const avance_porcentual = plan > 0 ? +(ejecutado / plan * 100).toFixed(2) : 0;

    const color_percent = (avance) => {

        if (plan === 0) return '#d3d3d3';
        if (avance == 0) return '#F02C00';
        if (avance < 30) return '#FC6903';
        if (avance < 50) return '#FC9603';
        if (avance < 70) return '#F3FF00';
        if (avance < 90) return '#AEFF00';
        if (avance <= 100) return '#02D61C';
        return '#00BDFF';
    }

    return (
        <div className='w-100 p-1'>

            <div className='w-100 p-1 round-m shadow-sm'
                style={{ overflow: "hidden", border: `2px solid ${dia ? color_percent(avance_porcentual) : 'white'}` }}>
                <table className='table'>
                    <thead>
                        <tr>
                            <th className={class1} style={{ width: "33.33%" }}>PLANEADO</th>
                            <th className={class1} style={{ width: "33.33%" }}>REALIZADO</th>
                            <th className={class1 + " text-xxs"} style={{ width: "33.33%" }}>HORAS NECESARIAS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className={class2}>{plan}</td>
                            <td className={class2} style={{ borderLeft: "solid 1px black", borderRight: "solid 1px black" }}>{ejecutado}</td>
                            <td className={class2}>{Math.ceil(plan / uh)}</td>
                        </tr>
                    </tbody>
                </table>
                <div className='w-100 text-center text-xs'>Avance del día: {+avance_porcentual.toFixed(2)}%</div>
            </div>

        </div>
    )
}

export default TablaAvanceUnDia;